(function($) {
    // @see: Membership_ContractFee
    var TYPE_MONTH = 1;
    var TYPE_BASE = 2;
    var TYPE_DEPENDENT = 3; 
    var TYPE_DUE = 4;

    // @see: Ca_Form_Element_CheckboxesAndValues
    var COL_NUMBER = 1;
    var COL_CHECKBOX = 2;
    var COL_DROPDOWN = 3;
    var COL_AUTOCOMPLETE = 4;
    var COL_TEXT = 5;
    var COL_HIDDEN = 6;

    // @see: Group
    var HOLD_MEMBERSHIP_TYPE_NO_CHARGE = 1;
    var HOLD_MEMBERSHIP_TYPE_CREDIT    = 2;
    var HOLD_MEMBERSHIP_TYPE_CHARGE    = 3;

    // @see: Group_Entity_UserGroup
    var TYPE_DOLLAR   = '$';
    var TYPE_PERCENT  = '%';

    var ERROR_NO_VALUE = 'Can not get a value';

    $.widget("ca.caCheckboxesValues", {
        _create : function() {               
            this.options.table_name = this.element.attr('id');            
            this.setChangeable(true);
            this.rows = [];     
            this.options.showPlaceholders = false;
            this.colHoldValue = [];
            this.chargeCount = 1;
            this.defaultValues = {};
            this.billingGroup = {
                amount_type: TYPE_DOLLAR,
                amount: 0
            };
            this.billedCols = {};

            this.options.prorateLastMonth = false;

            this.options.startDate = null;
            this.options.endDate = null;

            var self = this;

            if (this.options.allowFeeProration !== true) {
                this.options.allowFeeProration = false;
            }
            
            this.element.on('keyup', 'input[type=text]', function(){
                if ($(this).closest('td').hasClass('col-type-number')) {
                    this.value = this.value.replace(/[^0-9\.]/g, '');
                }
            });

            this.element.on('change', 'input[type=text]', function(){
                if ($(this).closest('td').hasClass('col-type-number')) {
                    self.setPlaceholders({
                        rows: self.defaultValues
                    });
                }
            });
        },

        findRowCell: function($el) {
            var index = $el.closest('td').index() - 1;
            return $el.closest('table')
                .find('tr')
                .find('td:eq('+index+')');
        },

        setChangeable: function(changeable, rowClass) {
            var self = this;
            this.options.changeable = changeable ? true : false;
            if (changeable) {
                this.element.off('click.checkboxesTable').on('click.checkboxesTable','tbody td', function(event, allowTrigger) {
                    if ($(this).hasClass('disabled')) {
                        event.preventDefault();
                        event.stopPropagation();
                        return;
                    }
                    if ($(this).parents('tr').hasClass('single')) {
                        $(this).parents('tr').find('td').removeClass('selected');
                        $(this).parents('tr').find('input').val(0);
                    }
                    if (!rowClass || $(this).parents('tr').hasClass(rowClass)) {
                        var input = $(this).find('input');
                        var element = $(this);
                        $(this).toggleClass('selected');
                        input.val($(this).hasClass('selected') ? 1 : 0);

                        var $colRow = self.findRowCell(input);
                        if (!event.isTrigger || allowTrigger) {
                            var type = $(input).closest('tr').data('type');

                            if (type == TYPE_MONTH && input.val() == 0) {
                                $colRow.each(function(){
                                    var td = $(this);
                                    var tr = td.closest('tr');
                                    if (tr.data('type') == TYPE_DUE && td.hasClass('selected')) {
                                        td.toggleClass('selected');
                                        td.find('input').val(0);
                                    }
                                });
                            }

                            if (type == TYPE_DUE) {
                                if (input.val() == 1) {
                                    $colRow.each(function(){
                                        var td = $(this);
                                        var tr = td.closest('tr');
                                        if (tr.data('type') == TYPE_MONTH && !td.hasClass('selected')) {
                                            td.trigger('click', [true]);
                                        }
                                    });
                                } else {
                                    if (self.options.isBillingForward) {
                                        var index = input.closest('td').index();
                                        if (index <= 2) {
                                            $.caConfirm(
                                                'Unchecking this box will cause the membership to not bill for this month.',
                                                'Warning', 
                                                'OK', 
                                                'Cancel',
                                                function() {},
                                                function() {
                                                    element.addClass('selected');
                                                    input.val(1);
                                                }
                                            );
                                        }
                                    }
                                }
                            }                            
                        }
                    }
                    return false;
                }).removeClass('disabled');
            } else {
                this.element.find('tbody').off('click.checkboxesTable').on('click.checkboxesTable','td', function() {
                    return false;
                }).addClass('disabled');
            }
            if (this.options.disabled_row_class) {
                this.element.find('.'+this.options.disabled_row_class).off('click.checkboxesTable').on('click.checkboxesTable','td', function() {
                        return false;
                }).addClass('disabled');
            }
        },

        applyValues: function(cols, values, defaultValues, billedCols) {
            var self = this;
            var childrow = 0;
            var colsLen = $.isNumeric(cols) ? cols : cols.length;
            var result = [];
            this.colHoldValue = [];

            if (billedCols !== undefined) {
                this.billedCols = billedCols;
            }

            for (var i = 0; i < this.rows.length; i++) {
                result[i] = [];
                if (this.rows[i].type == TYPE_DEPENDENT) {
                    childrow++;
                }
                for (var j = 0; j < colsLen; j++) {
                    var col = j+1;
                    var val = null;                    
                    var type = this.rows[i] ? this.rows[i].type : null;
                    var colHoldValue = null;

                    try {
                        if ($.isNumeric(cols)) {
                            // setting values to the monthly billing matrix
                            if ((values == null || values.length == 0) && ((type == TYPE_MONTH) || (type == TYPE_DUE && col == 1))) {
                                val = 1;
                            } else if (type == TYPE_DEPENDENT) {
                                val = values[type][childrow][col];
                                if (val === '' 
                                    && defaultValues[type] !== undefined
                                    && defaultValues[type][childrow] !== undefined
                                    && defaultValues[type][childrow][col] !== undefined
                                ) {
                                    colHoldValue = defaultValues[type][childrow][col];
                                }
                            } else {
                                val = values[type][col];
                                if (val === '' 
                                    && defaultValues[type] !== undefined
                                    && defaultValues[type][col] !== undefined
                                ) {
                                    colHoldValue = defaultValues[type][col];
                                }
                            }
                        } else {
                            // setting values ot interval fees
                            if (type == TYPE_DEPENDENT) {
                                val = values[type][childrow][cols[j].name];
                            } else {
                                val = values[type][cols[j].name];
                            }
                        }
                    } catch (e) {
                        // ignore type errors
                    }                    

                    if (colHoldValue === null) {
                        colHoldValue = val;
                    }

                    var isHolded = this.isHolded(col);
                    var holdValue = isHolded 
                        ? this.getHoldValue(type, colHoldValue, j, childrow) 
                        : null;

                    result[i][j] = {
                        value: (typeof val == 'undefined' ? null : val),
                        placeholder: '',
                        empty: false,
                        holded: isHolded,
                        holdValue: holdValue,
                        doNotBill: this.isDoNotBill(col),
                        disabled: this.isDisabled(type, i, col)
                    };
                }
            }

            result = this.removeExceededHolds(result);
            return result;
        },

        isHolded: function(col) {
            if (this.isDisabled(null, null, col) 
                && this.options.holdedCols 
                && this.options.holdedCols[col] !== undefined
            ) {
                return true;
            }

            var hold = this.options.holdParams;
            if (!hold) {
                return false;
            }

            if (hold.holdedCols && hold.holdedCols.length > 0) {
                return (hold.holdedCols[col] !== undefined);
            } else if (
                hold.dateFrom != '0000-00-00' 
                && this.isColInDateRange(col, hold.dateFrom, hold.dateTo, hold.holdIndefinitely)
            ) {
                return this.isColWillBeBilled(col, hold.dateFrom, hold.dateTo, hold.holdIndefinitely);
            } else {
                return false;
            }
        },

        isDoNotBill: function(col) {
            var params = this.options.doNotBill;

            if (!params || params.dateFrom == '0000-00-00') {
                return false;
            }

            if (this.isColInDateRange(col, params.dateFrom, params.dateTo)) {
                return this.isColWillNotBilled(col, params.dateFrom, params.dateTo);
            } else {
                return false;
            }
        },

        isDisabled: function(type, row, col) {
            var params = this.options.disabled;
            if (!params || params.length == 0) {
                return false;
            }

            var disabled = false;
            $.each(params, function(key, value){
                if ((value.type || value.row || value.col)
                    && (value.type == undefined || value.type == type)
                    && (value.row == undefined || value.row == row)
                    && (value.col == undefined || value.col == col)
                ) {
                    disabled = true;
                    return false;
                }
            });

            return disabled;
        },

        isColInDateRange: function(col, dateFrom, dateTo, indefinitely) {
            var colDateRange = this.getColDateRange(col);
            var colDateFrom = colDateRange[0];
            var colDateTo = colDateRange[1];

            return (dateFrom <= colDateTo && (dateTo > colDateFrom || dateTo == '0000-00-00' || indefinitely == '1'));
        },

        isColWillBeBilled: function(col, dateFrom, dateTo, indefinitely) {
            var nextBillDate = this.getNextBillDate();
            var colDateRange = this.getColDateRange(col);
            var colDateFrom = colDateRange[0];
            var colDateTo = colDateRange[1];            
            var billed = true;

            if (nextBillDate < colDateTo && nextBillDate >= colDateFrom) {

                if (nextBillDate < dateFrom || 
                    !(nextBillDate < dateTo || dateTo == '0000-00-00' || indefinitely == '1') 
                ) {
                    billed = false;
                }
            } else {
                if (nextBillDate > colDateTo) {
                    billed = false;
                }
            }
            return billed;
        },

        isColWillNotBilled: function(col, stopBillingDate, startBillingDate) {
            var nextBillDate = this.getNextBillDate();            
            var colDateRange = this.getColDateRange(col);
            var colDateFrom = colDateRange[0];
            var billDate = colDateFrom.split('-');
            billDate[2] = nextBillDate.split('-')[2];
            billDate = billDate.join('-');

            return (stopBillingDate <= billDate && startBillingDate > billDate);
        },

        getColDateRange: function(col) {
            var colDate = this.getColumnTitle(col).split('/');
            var colMonth = colDate[0];
            var colYear = '20'+colDate[1];
            var colStartDay = '01';
            var colEndDay = new Date(colYear, colMonth, 0).getDate();
            var colDateFrom = colYear+'-'+colMonth+'-'+colStartDay;
            var colDateTo = colYear+'-'+colMonth+'-'+colEndDay;
            return [colDateFrom, colDateTo];
        },

        refreshTableWithOption: function(option, value) {
            this.options[option] = value;
            this.values = this.getValues();
            this.setValues(this.values);
        },

        getNextBillDate: function() {
            return this.options.nextBillDate;
        },

        setNextBillDate: function(date) {
            this.options.nextBillDate = date;
            this.values = this.getValues();
            this.setValues(this.values);            
        },

        getHoldValue: function(type, colValue, col, childRow) {
            var hold = this.options.holdParams;
            if (hold
                && hold.holdedCols
                && hold.holdedCols[col+1] 
                && hold.holdedCols[col+1][type]
            ) {
                switch (type) {
                    case TYPE_BASE:
                        return hold.holdedCols[col+1][type];
                    case TYPE_DEPENDENT:
                        return hold.holdedCols[col+1][type][childRow];
                    default:
                        return colValue;

                }
            }
            var colValue = parseFloat(colValue);

            if (type == TYPE_MONTH || type == TYPE_DUE) {
                this.colHoldValue[col] = hold ? hold.holdValue : 0;
                return colValue;
            }            
            if (hold && hold.holdType) {
                switch (+hold.holdType) {
                    case HOLD_MEMBERSHIP_TYPE_NO_CHARGE:
                        return "0.00";
                    case HOLD_MEMBERSHIP_TYPE_CREDIT:
                        if (isNaN(colValue) || colValue < 0){
                            return "0.00";
                        } else {
                            if (this.colHoldValue[col] > colValue) {
                                this.colHoldValue[col] -= colValue;
                                colValue = 0;
                            } else {
                                colValue -= this.colHoldValue[col];
                                this.colHoldValue[col] = 0;
                            }
                            return colValue.toFixed(2);
                        }                        
                    case HOLD_MEMBERSHIP_TYPE_CHARGE:
                        return type == TYPE_BASE ? hold.holdValue : "0.00";
                }
            }
            return "0.00";
        },

        removeExceededHolds: function(data) {
            if (this.options.holdParams
                && this.options.holdParams.holdType == HOLD_MEMBERSHIP_TYPE_CREDIT
            ) {
                $.each(this.colHoldValue, function(col, remainValue){
                    if (remainValue > 0) {
                        $.each(data, function(rowNum, rowCols){
                            data[rowNum][col].holded = false;
                            data[rowNum][col].holdValue = null;
                        });
                    }
                });
            }
            return data;
        },

        createUserTable: function(rows, cols, values, dependents, startDate, holdParams, nextBillDate, doNotBill, billingGroup, billedCols) {
            var self = this;
            this.defaultValues = rows;
            cols = cols || this.options.columns;
            this.setShowPlaceholders(true);
            if (startDate) {
                this.options.startDate = startDate;
            }            
            if (holdParams) {
                this.options.holdParams = holdParams;
                if (holdParams.holdedCols) {
                    this.options.holdedCols = holdParams.holdedCols;
                }
            }
            if (nextBillDate) {
                this.options.nextBillDate = nextBillDate;
            }
            if (doNotBill) {
                this.options.doNotBill = doNotBill;
            }
            if (billingGroup) {
                billingGroup.amount = parseFloat(billingGroup.amount);
                this.billingGroup = billingGroup;
            }

            if (billedCols) {
                this.billedCols = billedCols;
                $.each(billedCols, function (col, billed) {
                    if (billed) {
                        if (!$.isArray(self.options.disabled)) {
                            self.options.disabled = [];
                        }
                        self.options.disabled.push({
                            col: col
                        });
                    }
                });
            }

            this.syncDependents(dependents); 
            this.values = this.applyValues(cols, values);
            this.buildTables(cols);
            this.setPlaceholders({rows: rows}, (values == null ? true : false), this.values);
            this.element.data('initialized', true);
        },

        createGroupTable: function(dependents, fees, cols) {
            cols = cols || this.options.columns;
            this.setShowPlaceholders(true);
            this.syncDependents(dependents);
            this.values = this.applyValues(cols, this.options.values);
            this.setPlaceholdersFromRow(fees, this.values);
            this.buildTables(cols);
            this.setValues( this.values );
            this.element.data('initialized', true);
        },

        updateGroupTable: function(dependents, fees, cols){
            if (dependents) {
                this.syncDependents(dependents);
            }

            this.values = this.getValues();

            var forwardMonthNum = this.options.isBillingForward ? 1 : 0;

            for (var i = this.values[0].length; i <= cols; i++) {
                this.values[0][i] = {empty: false, value: 1};
                if (i <= forwardMonthNum) {
                    this.values[1][i] = {empty: false, value: 1};
                }
            }

            this.buildTables(cols);
            this.setValues(this.values);

            this.values = this.getValues();
            this.setPlaceholdersFromRow(fees, this.values);
            this.buildTables();            

            this.setValues(this.values);
        },

        resizeTable: function(columns, rows, setTrueToNewColumns){
            this.values = this.getValues();
            this.buildTables(columns, rows);
            
            if (setTrueToNewColumns) {
                if (this.values[0] === undefined) {
                    this.values[0] = [];
                    this.values[1] = [{empty: false, value: 1}];
                }
                
                for (var i = this.values[0].length; i <= columns; i++) {
                    this.values[0][i] = {empty: false, value: 1};
                }
            }
            
            this.setValues(this.values);
            this.element.trigger('didResizeTable');
        },

        buildTables: function( columns, rows )
        {
            var numberArray = function(a,b,c){c=[];while(a--){c[a]=a+b}return c};
            var $container = $('<div></div>');

            if( !columns ){
                columns = this.options.columns;
            } else {
                this.options.columns = columns;
            }

            if( !rows ){
                rows = this.rows;
            } else {
                this.rows = rows;
            }

            var postProcessingQueue = [];
            if ($.isNumeric(columns)) {
                var max_col = this.options.colsInRow;
                var start = 1;
                var length = columns > max_col ? max_col : columns;
                var postProcessingQueue = [];
                while( start <= columns )
                {               
                    var $t = this.generateEmptyTable(rows, numberArray(length, start), postProcessingQueue);
                    $container.append( $t );

                    start += max_col;
                    length = columns - start + 1;
                    length = length > max_col ? max_col : length;
                }
            } else {
                var $t = this.generateEmptyTable(rows, columns, postProcessingQueue);            
                $container.append( $t );                
            }

            this.element.empty();
            this.element.append( $container.find('>table'));
            this.setChangeable( this.options.changeable, 'row');

            if (postProcessingQueue.length > 0) {
                $.each(postProcessingQueue, function(){
                    this();
                });
            }
        },

        getValues: function()
        {
            var data = [];
            var offset = 0;
            var self = this;
            this.colHoldValue = [];
            this.element.find('>table').each(function(i, table) {
                var childRow = 0;
                $(table).find('tbody tr').each(function(row, tr) {
                    var type = $(tr).data('type');
                    if (type == TYPE_DEPENDENT) {
                        childRow++;
                    }
                    $(tr).find('>td').each(function(col, td) {
                        var $td = $(td);
                        try {
                            var value = self.getCellValue(this);
                        } catch (e) {
                            if (e == ERROR_NO_VALUE) {
                                return true;
                            } else {
                                throw e;
                            }
                        }
                        if (!data[row]) {
                            data[row] = [];
                        }
                        var placeholder = $td.find('input:not([name=""],[name^=keep-])').attr('placeholder');
                        var realCol = col + offset;
                        var isHolded = self.isHolded(realCol + 1);
                        var colHoldValue = value !== '' ? value : placeholder;                        
                        var holdValue = isHolded 
                            ? self.getHoldValue(type, colHoldValue, realCol, childRow) 
                            : null;
                        data[row][realCol] = {
                            value: value,
                            placeholder: placeholder,
                            empty: $td.hasClass('empty'),
                            holded: isHolded,
                            holdValue: holdValue,
                            doNotBill: self.isDoNotBill(realCol + 1),
                            disabled: self.isDisabled(type, row, realCol + 1)
                        }
                    })
                });
                offset += $(table).find('thead tr td').length - 1;
            });
            data = this.removeExceededHolds(data);
            return data;
        },

        getCellValue: function(td)
        {
            var $td = $(td);
            var colType = this.getColType($td);
            switch (colType) {
                case 'col-type-number':
                case 'col-type-text':
                case 'col-type-checkbox':
                case 'col-type-hidden':
                    return this.getInputValue($td);
                case 'col-type-dropdown':
                    return this.getDropdownValue($td);                    
                case 'col-type-autocomplete':
                    return this.getAutocompleteValue($td);
                default:
                    throw ERROR_NO_VALUE;
            }       
        },

        getInputValue: function($td) 
        {
            return $td.find('input:not([name=""],[name^=keep-])').val();
        },

        getDropdownValue: function($td)
        {
            var select = $td.find('select').get(0);            
            return $(select).val();
        },

        getAutocompleteValue: function($td)
        {
            var input = $td.find('>input[type=hidden]').get(0);
            return $(input).val();
        },

        getColType: function($td)
        {
            var colClass = $td.attr("class").match(/col-type-[\w]+/);
            return (colClass && colClass[0])
                ? colClass[0]
                : null;
        },

        setValues: function(data)
        {
            data = data || this.values;
            var offset = 0;
            var self = this;
            this.element.find('>table').each( function(i, table) {
                $(table).find('tbody tr').each( function(row, tr) {
                    $(tr).find('>td').each( function(col, td) {                                
                        if( data[row] && data[row][col+offset]) {
                            var field = data[row][col+offset];
                            var $td = $(td);

                            if (field.empty == true) {
                                $td.addClass('empty');
                            } else {
                                var colType = self.getColType($td);
                                switch (colType) {
                                    case 'col-type-number':
                                        self.setNumberValue($td, row, field);
                                        break;                                    
                                    case 'col-type-text':
                                        self.setTextValue($td, row, field);
                                        break;
                                    case 'col-type-checkbox':
                                        self.setCheckboxValue($td, row, field);
                                        break;
                                    case 'col-type-dropdown':
                                        self.setDropdownValue($td, row, field);
                                        break;
                                    case 'col-type-autocomplete':
                                        self.setAutocompleteValue($td, row, field);
                                        break;
                                    case 'col-type-hidden':
                                        self.setHiddenValue($td, row, field);
                                        break;
                                }                            
                            }
                        }
                    });
                });
                offset += $(table).find('thead tr td').length - 1;
            });
        },

        setTextValue: function($td, row, field)
        {
            var input = $td.find('>input:not(.cv-internal)').get(0);

            if ($(input).prop('readonly')) {
                var $hidden = $(input).siblings('input[type=hidden].cv-internal');
                if ($hidden.length > 0) {
                    $hidden.val(field.value);
                    $hidden.attr('placeholder', field.placeholder);
                }

                if ($td.hasClass('value-doNotBill')) {
                    input.value = '';
                } else if ($td.hasClass('value-holded')) {
                    input.value = field.holdValue;
                }
            } else {
                input.value = field.value;
            }

            if (this.options.showPlaceholders) {
                var ph = field.placeholder;
                $(input).attr('placeholder', (ph === "" || ph == null) ? "" : field.placeholder);
            }                
        },

        setNumberValue: function($td, row, field)
        {
            var input = $td.find('>input:not(.cv-internal)').get(0);

            if (field.disabled) {
                $(input).prop('readonly', true);
            }

            if ($(input).prop('readonly')) {
                var $hidden = $(input).siblings('input[type=hidden].cv-internal');
                if ($hidden.length > 0) {
                    $hidden.val(field.value);
                    $hidden.attr('placeholder', field.placeholder);
                }     
                
                if ($td.hasClass('value-doNotBill')) {
                    input.value = '0.00';
                } else if ($td.hasClass('value-holded')) {
                    input.value = parseFloat(field.holdValue).toFixed(2);
                } else {
                    input.value = parseFloat(field.value).toFixed(2);
                }
            } else {
                input.value = parseFloat(field.value).toFixed(2);
            }

            if (isNaN(input.value)) {
                input.value = '';
            }

            if (this.options.showPlaceholders) {
                var ph = field.placeholder;
                $(input).attr('placeholder', (ph === "" || ph == null) ? "" : field.placeholder);
            }

            var $colRow = $td.closest('table').find('tr').find('td:eq('+($td.index() - 1)+')');
            $colRow.each(function(){
                var type = $(this).closest('tr').data('type');
                if (type == TYPE_MONTH) {                    
                    if (!$(this).hasClass('disabled')) {
                        $(input).prop('readonly', !$(this).hasClass('selected'));
                    }
                }
            });
        },

        setDropdownValue: function($td, row, field)
        {
            var select = $td.find('select').get(0);            
            $(select).val(field.value);
        },

        setAutocompleteValue: function($td, row, field)
        {
            if (this.options.autocomplete && this.options.autocomplete[row + 1]) {
                var options = this.options.autocomplete[row + 1];
                var input = $td.find('>input[type=hidden]').get(0);

                if (field.value && options.label) {                    
                    $(input).caAutocomplete('setItem', {
                        id: field.value,
                        label: options.label
                    });
                }
                if (options.options) {
                    $.each(options.options, function(option, value){
                        $(input).caAutocomplete('option', option, value);
                    });
                }
            }
        },

        setCheckboxValue: function($td, row, field)
        {
            var input = $td.find('>input:not(.cv-internal)').get(0);

            if (field.value == 1 && input.value != 1) {
                $td.trigger('click');
            }                 

            // processing the hold values                                                       
            if (this.rows[row].type == TYPE_MONTH) {
                var $colRow = $td.closest('table').find('tr').find('td:eq('+($td.index() - 1)+')');
                var wasHolded = $td.hasClass('holded');
                var didNotBill = $td.hasClass('doNotBill');
                var action = null;
                var states = [{
                    changed: (field.doNotBill ^ didNotBill),
                    exists: didNotBill,
                    cssClass: 'doNotBill',
                    others: wasHolded
                }, {
                    changed: (field.holded ^ wasHolded),
                    exists: wasHolded,
                    cssClass: 'holded',
                    others: didNotBill
                }];

                $.each(states, function(){
                    if (this.changed) {
                        if (!this.others) {
                            action = this.exists ? 'restore' : 'keep';
                        }
                        $td.toggleClass(this.cssClass, !this.exists);
                        $colRow.toggleClass('value-'+this.cssClass, !this.exists);
                    }
                });
                
                switch (action) {
                    case 'keep':
                        $colRow.find('input[type=text]').each(function(key, col){
                            $(this).after($('<input type="hidden" name="'+this.name+'" class="cv-internal" />'));
                            this.name = "keep-" + this.name;
                        });

                        $td.addClass('disabled');
                        $colRow.find('input[type=text]').prop('readonly', true);
                        $colRow.find('input[type=hidden]').closest('td').addClass('disabled');
                        break;

                    case 'restore':
                        $colRow.find('input[type=text]').each(function(){
                            var $hidden = $(this).siblings('input[type=hidden].cv-internal');
                            if ($hidden.length > 0) {
                                this.name = $hidden[0].name;
                                this.value = $hidden[0].value;
                                $hidden.remove();
                            }
                        });
                        
                        $td.removeClass('disabled');
                        $colRow.find('input[type=text]').prop('readonly', false);
                        $colRow.find('input[type=hidden]').closest('td').removeClass('disabled');
                        break;
                }
            }
            if (field.disabled) {
                $td.addClass('disabled');
            }
        },

        setHiddenValue: function(td, row, field)
        {
            var input = td.find('>input:not(.cv-internal)').get(0);

            input.value = field.value;
        },

        setPlaceholders: function(data, cols, vals)
        {
            this.defaultValues = data.rows;
            vals = vals || this.getValues();
            
            var self = this;
            var month = [];

            if (data.rows[TYPE_MONTH]) {
                $.each(vals[0], function() {
                    month.push(this.value);
                });
            }

            function _setPlaceholder(pos, row) {
                var col = 0;

                var lastCol;
                $.each(row, function(key, val) {
                    lastCol = key;
                });

                $.each(row, function (key, value) {
                    if (vals[pos][col] !== undefined) {
                        var discount = colDiscount[col];
                        if (discount !== undefined 
                            && (vals[pos][col].value == null || vals[pos][col].value.length == 0)
                        ) {
                            if (self.billingGroup.amount_type == TYPE_PERCENT) {
                                value -= self.applyDiscount(value);
                            } else {
                                if (discount > value) {
                                    colDiscount[col] -= value;
                                    value = 0;
                                } else {
                                    value -= discount;
                                    colDiscount[col] = 0;
                                }
                            }
                        }

                        if (col == 0) {
                            value *= self.chargeCount;
                        } else if ((col + 1) == lastCol && self.options.prorateLastMonth && self.options.endDate) {
                            var endDate = new Date(self.options.endDate);
                            var lastDay = new Date(endDate.getFullYear(), endDate.getMonth() + 1, 0);

                            value *= endDate.getDate() / lastDay.getDate();
                        }

                        value = (+value).toFixed(2);

                        if (self.billedCols && self.billedCols[col + 1] === true)  {
                            value = '0.00';
                        }

                        if (data.rows[TYPE_MONTH]) {
                            if (month[col] == 1) {
                                vals[pos][col].placeholder = value;
                            } else {
                                vals[pos][col].placeholder = '';
                                vals[pos][col].value = '';
                            }
                        } else {
                            vals[pos][col].placeholder = value;
                        }
                    }
                    col++;
                });
            }

            var colSum = [];
            function _sumPlaceholder(pos, row) {
                var col = 0;
                $.each(row, function (key, value) {   
                    if (vals[pos][col] !== undefined ) {
                        if (colSum[col] === undefined) {
                            colSum[col] = 0;
                        }
                        if (!(data.rows[TYPE_MONTH] && month[col] != 1)) {
                            if (vals[pos][col].value == null || vals[pos][col].value.length == 0) {
                                colSum[col] += +value;
                            }
                        }
                    }
                    col++;
                });
            }

            this.iterateRows(data.rows, _sumPlaceholder);
            var colDiscount = this.calculateDiscount(colSum);
            this.iterateRows(data.rows, _setPlaceholder);
            this.values = vals;
            this.setValues(this.values);
        },

        calculateDiscount: function(cols)
        {
            var self = this;
            var colDiscount = [];
            $.each(cols, function(colNum, colSum){
                colDiscount[colNum] = self.applyDiscount(colSum);
            });
            return colDiscount;
        },

        updateProrate: function(billingType, prorateFrom) {
            this.chargeCount = (billingType == 1 || !this.options.allowFeeProration)
                ? 1
                : this.prorateDate(prorateFrom);

            if (this.element.data('initialized') == true) {
                this.setPlaceholders({rows: this.defaultValues});
            }
        },

        prorateDate: function(date) {
            var dateParts = date.split('-');
            var year = dateParts[0];
            var month = dateParts[1];
            var day = dateParts[2];

            var daysInMonth = new Date(year, month, 0).getDate();
            var lastDay = daysInMonth;

            if (this.options.endDate) {
                var endDate = new Date(this.options.endDate);
                if (year == endDate.getFullYear() && parseInt(month) == (endDate.getMonth() + 1)) {
                    if (endDate.getDate() >= parseInt(day)) {
                        lastDay = endDate.getDate();
                    } else {
                        lastDay = day - 1;
                    }
                }
            }

            var billableDays = lastDay - day + 1;

            return billableDays / daysInMonth;
        },

        applyDiscount: function(val) {
            var amount = 0;
            
            if (this.billingGroup.amount_type == TYPE_DOLLAR) {
                amount = (this.billingGroup.amount >= val) 
                    ? val 
                    : this.billingGroup.amount;
            } else if (this.billingGroup.amount_type == TYPE_PERCENT) {
                amount = (this.billingGroup.amount >= 100) 
                    ? val 
                    : val * this.billingGroup.amount / 100;
            }
            
            return amount;
        },

        iterateRows: function(rowData, callback)
        {
            var childrow = 0;     
            $.each( this.rows, function( pos, valrow ){
                var row = rowData[ valrow.type ];
                if( row == null ){
                    return;
                }
                switch( valrow.type ){
                    case TYPE_BASE:       
                        callback(pos, row);                        
                        break;
                        
                    case TYPE_DEPENDENT:
                        childrow++;
                        callback(pos, row[childrow]);
                        break;
                }
            });
        },

        setPlaceholdersFromRow: function( data, vals )
        {
            vals = vals || this.getValues();
            var dataRow = 0;
            var billMonth = [];

            $.each( this.rows, function( pos, row ){
                if( row.type == TYPE_MONTH ){
                    billMonth = vals[ pos ];
                }
            });

            $.each( this.rows, function( pos, row ){
                if( row.type == TYPE_BASE || row.type == TYPE_DEPENDENT ){
                    $.each( vals[ pos ], function( col, value ){            
                        if (billMonth.length > 0) {
                            if( billMonth[ col ] && billMonth[ col ].value == 1 ){            
                                vals[ pos ][ col ].placeholder = data[ dataRow ]['membership_fee'];
                            } else { 
                                vals[ pos ][ col ].placeholder = '-';
                            }
                        } else {
                            switch (col) {
                                case 0:
                                    vals[pos][col].placeholder = data[ dataRow ]['membership_fee'];
                                    break;
                                case 1:
                                    if (data[ dataRow ]['start_age'] != null) {
                                        vals[pos][col].placeholder = data[ dataRow ]['start_age'];
                                    } else {
                                        vals[pos][col].empty = true;
                                    }
                                    break;                                    
                                case 2:
                                    if (data[ dataRow ]['end_age'] != null) {
                                        vals[pos][col].placeholder = data[ dataRow ]['end_age'];
                                    } else {
                                        vals[pos][col].empty = true;
                                    }
                                    break;                                                                        
                            }
                            
                        }
                    });                    
                    dataRow++;
                }   
            });

            this.values = vals;            
        },

        setShowPlaceholders: function( show )
        {
            this.options.showPlaceholders = show;
        },

        getColumnTitle: function(column)
        {
            if ($.isNumeric(column)) {
                if (this.options.startDate) {
                    column--;

                    var startDate = new Date(this.options.startDate + 'T00:00');
                    startDate.setDate(1);
                    startDate.setMonth(startDate.getMonth() + column);

                    return $.datepicker.formatDate('mm/y', startDate);
                }

                return column;
            } else if (column.title) {
                return column.title;
            }

            return '';
        },

        generateEmptyTable: function(rows, columns, postProcessingQueue) 
        {
            var self = this;    
            var html = '<table class = "checkboxes-table ' + this.options.table_name + '"><thead class="thead"><tr>';
            if (!self.options.noRowTitles) {
                html += '<td>' + (this.options.title ? this.options.title : '') + '</td>';
            }

            $j.each(columns, function(index, column) {
                var className = (column.type && column.type == COL_HIDDEN)
                    ? 'class="col-type-hidden"'
                    : '';

                html += '<td ' + className + '>' + self.getColumnTitle(column) + '</td>';
            });

            if (this.options.removableRows) {
                html += '<td class="gray-cell"></td>';
            }

            html += '</thead><tbody></tbody></table>';

            var $table = $(html);
            var self = this;        
            var dependent = 0;

            jQuery.each( rows, function (row_index, row) {                
                if (row.type == TYPE_DEPENDENT) {
                    dependent++;
                }
                var $tr = self.generateTableRow(row_index, row, dependent, columns, postProcessingQueue);
                $table.find('tbody').append($tr);
            });            

            return $table;
        },

        generateTableRow: function(row_index, row, dependent, columns, postProcessingQueue)
        {
            var self = this;
            var $tr = $('<tr>');
            $tr.data('type', row.type);

            if (row.type == TYPE_MONTH || row.type == TYPE_DUE) {
                $tr.addClass('row');
            } else if (row.type == TYPE_DEPENDENT) {
                $tr.addClass('value-row dependent');
                $tr.data('num', dependent);
            } else {
                $tr.addClass('value-row');
            }

            if (!self.options.noRowTitles) {
                $tr.append($('<th>').text(row.title));
            }                

            jQuery.each(columns, function( col_index, col ){    
                if ($.isNumeric(col)) {
                    var col_name = col;
                    col_index = col - 1;

                    if (row.type == TYPE_MONTH || row.type == TYPE_DUE) {
                        var col_type = COL_CHECKBOX;
                    } else {
                        var col_type = COL_NUMBER;
                    }
                } else {
                    var col_name = col.name;

                    if (col.type) {
                        var col_type = col.type;
                    } else {
                        var col_type = COL_NUMBER;
                    }
                }

                var $td = $('<td>');
                if(( self.values 
                    && self.values[ row_index ] 
                    && self.values[ row_index ][ col_index ] 
                    && self.values[ row_index ][ col_index ].empty == true 
                )){
                    $td.addClass('empty').append($('<input/>')
                        .attr('type', 'hidden')
                    );
                } else {
                    switch (col_type) {
                        case COL_TEXT:
                            $td = self.buildTextCol(row, col, dependent, col_name);
                            break;
                        case COL_CHECKBOX:
                            $td = self.buildCheckboxCol(row, col_name);
                            break;
                        case COL_DROPDOWN:
                            $td = self.buildDropdownCol(row, col, dependent, col_name, postProcessingQueue);
                            break;
                        case COL_AUTOCOMPLETE:                                
                            $td = self.buildAutocompleteCol(row, col, dependent, col_name, postProcessingQueue);
                            break;
                        case COL_NUMBER:
                            $td = self.buildNumberCol(row, col, dependent, col_name);
                            break;
                        case COL_HIDDEN:
                            $td = self.buildHiddenCol(row, col, dependent, col_name);
                            break;
                    }
                }
                $td.appendTo($tr);
            });

            if (self.options.removableRows) {
                var $td = $('<td>');
                if (dependent > 1) {
                    $td.addClass('delete-row gray-cell')
                        .append($('<span>')
                            .addClass('del')
                        );
                } else {
                    $td.addClass('gray-cell');
                }
                $td.appendTo($tr);
            }

            return $tr;
        },

        buildTextCol: function(row, col, dependent, col_name)
        {
            var $td = $('<td>');
            if (row.type == TYPE_DEPENDENT) {
                var name = this.options.table_name+'['+row.type+']['+dependent+']['+col_name+']';

                $td.append($('<input/>')
                    .attr('type', 'text')
                    .attr('name', name)
                    .val('')
                );
            } else {
                var name = this.options.table_name+'['+row.type+']['+col_name+']';

                $td.append($('<input/>')
                    .attr('type', 'text')
                    .attr('name', name)
                    .val('')
                    .attr('size', 10)
                    .addClass('ca-text-field')
                );
            }
            $td.addClass('col-type-text');
            return $td;
        },

        buildNumberCol: function(row, col, dependent, col_name)
        {
            return this.buildTextCol(row, col, dependent, col_name)
                .removeClass('col-type-text')
                .addClass('col-type-number');
        },

        buildCheckboxCol: function(row, col_name)
        {
            var $td = $('<td>');
            var name = this.options.table_name+'['+row.type+']['+col_name+']';
            $td.append($('<input/>')
                .attr('type', 'hidden')
                .attr('name', name)
                .val(0)
            ).addClass('col-type-checkbox');
            return $td;
        },

        buildDropdownCol: function(row, col, dependent, col_name, postProcessingQueue)
        {
            var self = this;
            var $td = $('<td>');
            var name = this.options.table_name+'['+row.type+']['+dependent+']['+col_name+']';
            $td.addClass('col-type-dropdown')
                .append($('<div/>')
                    .addClass('ca-select')
                    .append($('<select>')
                        .attr('name', name)
                        .append((function(){
                            if (col.list && col.list.length > 0) {
                                return $.map(col.list, function(item){
                                    return $('<option>').text(item.name)
                                        .val(item.value)
                                        .get(0).outerHTML;
                                }).join('');
                            }                                
                        })())
                    )
                )
            ;
            if (col.onChange) {
                postProcessingQueue.push(function(){
                    $("select[name='"+name+"']").on('focus', function(){
                        $(this).data('lastValue', this.value);
                    });

                    $("select[name='"+name+"']").on('change', function(){
                        self[col.onChange](this);
                        $(this).data('lastValue', this.value);
                    });
                });                                    
            }   
            return $td;         
        },

        buildAutocompleteCol: function(row, col, dependent, col_name, postProcessingQueue)
        {
            var self = this;
            var $td = $('<td>');
            var name = this.options.table_name+'['+row.type+']['+dependent+']['+col_name+']';
            var id = this.nameToId(name);

            var $autocompleteWrapper = $('<div>')
                .attr('id', id + '-wrapper')
                .attr('class', 'tagsinput ca-autocomplete');

            $autocompleteWrapper.append(
                $('<input/>')
                    .attr('id', id)
                    .attr('type', 'text')
                    .attr('class', 'add-new ca-text-field')
                    .attr('name', 'add-new-child-to-' + id),
                $('<div>')
                    .attr('class', 'tags_clear')
            );
            $td.append($autocompleteWrapper)
                .addClass('col-type-autocomplete ca-pro-ui');

            postProcessingQueue.push(function(){
                var params = $.extend({fieldName: name}, col.params);
                if (params.change) {
                    params.change = self[params.change]
                        ? $.proxy(self[params.change], self)
                        : null;
                }
                $('#' + id).caAutocomplete(params);
            });
            return $td;
        },

        buildHiddenCol: function(row, col, dependent, col_name)
        {
            var td = $('<td>');

            var name = (row.type == TYPE_DEPENDENT)
                ? this.options.table_name + '[' + row.type + '][' + dependent + '][' + col_name + ']'
                : this.options.table_name + '[' + row.type + '][' + col_name + ']';

            td.append($('<input/>')
                .attr('type', 'hidden')
                .attr('name', name)
                .val('')
            );

            td.addClass('col-type-hidden');

            return td;
        },

        syncDependents: function(dependentRows)
        {            
            var rows = [];

            $.each(this.options.rows, function(id, row) {
                if (row.type != TYPE_DEPENDENT) {
                    rows.push(row);
                }
            }); 

            if (dependentRows) {
                $.each(dependentRows, function(i, row) {
                    if (typeof row == 'string') {
                        rows.push({
                            title: row,
                            type: TYPE_DEPENDENT
                        });
                    } else {
                        rows.push({
                            title: row.title,
                            type: row.type
                        });
                    }
                });
            }

            this.rows = rows;
        },

        removeDependent: function(num, dependents)
        {            
            var tbody = this.element.find('tbody')[0];
            var diff = $(tbody).find('tr').length - $(tbody).find('tr.dependent').length - 1;
            var data = this.getValues();
            data.splice( num + diff, 1 );            

            this.syncDependents(dependents);
            this.buildTables();
            this.setValues(data);
        },

        addDependentRow: function(title)
        {            
            var dependents = [];
            $.each(this.rows, function(id, row) {
                if (row.type == TYPE_DEPENDENT) {
                    dependents.push(row);
                }
            }); 
            
            var row = {
                title: title,
                type: TYPE_DEPENDENT
            };
            dependents.push(row);
            var postProcessingQueue = [];

            var $tr = this.generateTableRow(null, row, dependents.length, this.options.columns, postProcessingQueue);
            this.element.find('>table').append($tr);

            if (postProcessingQueue.length > 0) {
                $.each(postProcessingQueue, function(){
                    this();
                });
            }

            this.syncDependents(dependents);
        },

        removeRow: function(pos)
        {
            var $tr = this.element.find('>table>tbody>tr:eq('+pos+')');
            var self = this;
            var dependents = [];
            var tbody = this.element.find('tbody')[0];            
            $(tbody).find('tr.dependent').each(function(){
                if ($tr[0] !== this) {
                    dependents.push({
                        title: self.rows[pos] ? self.rows[pos].title : '',
                        type: TYPE_DEPENDENT
                    });
                }
            });
            this.syncDependents(dependents);
            $tr.remove();
        },
        
        nameToId: function(name)
        {
            return name.replace(/[\[\]\'\"]/g, function(s, key) {
                var replacements = {
                    '[': '-',
                    ']': '' ,
                    '"': '-',
                    "'": '-'
                };
                return (replacements[s] === undefined) ? s : replacements[s];
            });
        },

        getHoldedCols: function()
        {
            var values = this.getValues();
            var holdedCols = [];
            $.each(values, function(rowNum, row){
                var holdedColNum = null;
                $.each(row, function(colNum, col){
                    if (col.holded) {
                        holdedCols.push(colNum + 1);
                    }
                });
                return false;
            });
            return holdedCols;
        }
    });
})(jQuery);
